import React from "react"
import { StyleSheet, View } from "react-native"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import { BulletTextM } from "@common/components/text/BulletTextM"
import FilledButtonM from "@common/components/button/FilledButtonM"
import ObjectiveSubjectsBadges from "@common/components/objectives/ObjectiveSubjectsBadges"
import moment from "moment"
import { formatHoursPerWeek } from "@common/utils/creditCalculation"

export const NewSubscriptionPlanCard = ({
    plan,
    openEditPlanModal,
    subjects,
}) => {
    return (
        <View style={[styles.card]}>
            <View style={styles.row}>
                <TextM
                    fontWeight="Bold"
                    fontSize={18}
                    color={theme.colors.black}
                >
                    Votre formule
                </TextM>
                {openEditPlanModal && (
                    <FilledButtonM
                        icon="pencil"
                        label="Modifier"
                        mode="outlined"
                        style={{ width: 120 }}
                        contentStyle={{ height: 30 }}
                        labelStyle={{ fontSize: 10, marginVertical: 0 }}
                        onPress={openEditPlanModal}
                    />
                )}
            </View>
            <View>
                {[
                    `${formatHoursPerWeek(plan.hoursPerWeek)} par semaine`,
                    plan.offerType === "essential"
                        ? "Cours partagés"
                        : "Cours particuliers",
                ].map((detail) => (
                    <BulletTextM key={detail} text={detail} />
                ))}
                <BulletTextM
                    text={`Matières :`}
                    endComponent={
                        <ObjectiveSubjectsBadges
                            objective={{
                                subject_ids: subjects.map(
                                    (subject) => subject.id
                                ),
                                type: "level_up",
                            }}
                            schoolSubjects={subjects}
                            tinyMode={false}
                            truncateNames={false}
                            style={{ gap: 10 }}
                        />
                    }
                />
                <TextM
                    fontWeight="Bold"
                    fontSize={14}
                    color={theme.colors.black}
                    style={{ marginTop: 10 }}
                >
                    Durée de l'accompagnement
                </TextM>
                <View style={styles.tagsRow}>
                    {plan.withCommitment ? (
                        <>
                            <View style={styles.tagGreen}>
                                <TextM fontWeight="Bold" fontSize={11} color="#1B7A3D">
                                    1er mois sans engagement
                                </TextM>
                            </View>
                            <View style={styles.tagDefault}>
                                <TextM fontWeight="Medium" fontSize={11} color={theme.colors.grey}>
                                    Puis {plan.engagementDuration - 1} mois flexibles
                                </TextM>
                            </View>
                            <View style={styles.tagDefault}>
                                <TextM fontWeight="Medium" fontSize={11} color={theme.colors.grey}>
                                    Pause vacances 3 mois sans frais
                                </TextM>
                            </View>
                        </>
                    ) : (
                        <View style={styles.tagGreen}>
                            <TextM fontWeight="Bold" fontSize={11} color="#1B7A3D">
                                Zéro engagement
                            </TextM>
                        </View>
                    )}
                </View>
                <TextM
                    fontSize={12}
                    color={theme.colors.light}
                    style={{ fontStyle: "italic", marginTop: 8 }}
                >
                    Début des cours : le {moment(plan.startDate).format("D MMMM YYYY")}
                </TextM>
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    card: {
        padding: 20,
        borderRadius: 20,
        gap: 15,
        borderWidth: 1,
        borderColor: theme.colors.lightMore,
        backgroundColor: theme.colors.white,
    },
    row: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 10,
        flexWrap: "wrap",
    },
    tagsRow: {
        flexDirection: "row",
        flexWrap: "wrap",
        gap: 8,
        marginTop: 10,
    },
    tagGreen: {
        backgroundColor: "#E6F4EA",
        paddingHorizontal: 10,
        paddingVertical: 5,
        borderRadius: 20,
    },
    tagDefault: {
        backgroundColor: theme.colors.lightMore,
        paddingHorizontal: 10,
        paddingVertical: 5,
        borderRadius: 20,
    },
})
